export const trimFields = <T>(obj: T): T => {
  if (typeof obj === 'string') {
    return obj.trim() as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(trimFields) as T;
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj as Record<string, unknown>).map(([key, value]) => [
        key,
        trimFields(value),
      ]),
    ) as T;
  }

  return obj;
};
